import { render, staticRenderFns } from "./CardCuponInfo.vue?vue&type=template&id=09a39a5c&scoped=true&"
import script from "./CardCuponInfo.vue?vue&type=script&lang=js&"
export * from "./CardCuponInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardCuponInfo.vue?vue&type=style&index=0&id=09a39a5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a39a5c",
  null
  
)

export default component.exports